// extracted by mini-css-extract-plugin
export var activeDot = "_5p-c";
export var buttonContainer = "_5p-9";
export var channelButton = "_5p-a";
export var clickable = "_5p-d";
export var content = "_5p-0";
export var contentFull = "_5p-2";
export var contentThird = "_5p-1";
export var contentWrapper = "_5p-7";
export var description = "_5p-5";
export var heightShort = "_5p-f";
export var image = "_5p-3";
export var imageContainer = "_5p-4";
export var selectButton = "_5p-e";
export var spinnerContainer = "_5p-b";
export var titleContent = "_5p-8";
export var titleWrapper = "_5p-6";